'use client';

import { useLanguage } from "@/app/api/LanguageContext";
import { useRouter, usePathname } from 'next/navigation';
import React, { useEffect, useState } from 'react';
import ReactCountryFlag from "react-country-flag";
import styles from './LanguageSelector.module.css';
import Loading from "@/app/loading";

const redirects = {
    '/en/faq': '/en/preguntas-frecuentes',
    '/en/about': '/en/sobre-evanhub',
    '/en/bussiness-consulting': '/en/asesoria-empresarial',
    '/en/team': '/en/equipo',
    '/en/news': '/en/noticias',
    '/en/terms-and-conditions': '/en/terminos-y-condiciones',
    '/en/privacy-policies': '/en/politicas-de-privacidad',
    '/en/contact': '/en/contacto',
    '/en/cookie-policies': '/en/politicas-de-cookies',
    '/en/refund-policies': '/en/politicas-de-reembolso',
    '/en/areas/psychiatric-evaluation': '/en/areas/evaluacion-psiquiatrica',
    '/en/areas/psychological-evaluation': '/en/areas/evaluacion-psicologica',
    '/en/areas/neurological-evaluation': '/en/areas/evaluacion-neurologica',
    '/en/areas/legal-assessment': '/en/areas/evaluacion-juridica',
    '/en/informed-consent': '/en/consentimiento-informado',
};

const postMapping = {
    '/en/noticias/': '/en/news/',
    '/es/news/': '/es/noticias/',
};


const LanguageSelector = () => {
    const { locale, changeLocale } = useLanguage();
    const router = useRouter();
    const pathname = usePathname(); // Using pathname directly
    const [isOpen, setIsOpen] = useState(false);
    const [loading, setLoading] = useState(true);

    // Redirect logic on initial load if URL matches
    // Sincronizar el estado del contexto con el prefijo de la URL sin forzar recargas
    useEffect(() => {
        const isEnPath = pathname.startsWith('/en');
        const isEsPath = pathname.startsWith('/es');

        if (isEnPath && locale !== 'en') {
            changeLocale('en');
        } else if (isEsPath && locale !== 'es') {
            changeLocale('es');
        }
    }, [pathname, locale, changeLocale]);


   


    const handleChange = (newLocale) => {
        // Cambiar el idioma
        changeLocale(newLocale);

        // Crear mapeo de rutas con sus versiones en inglés y español
        const routesMapping = {
            '/sobre-evanhub': '/about',
            '/asesoria-empresarial': '/bussiness-consulting',
            '/equipo': '/team',
            '/noticias': '/news',
            '/terminos-y-condiciones': '/terms-and-conditions',
            '/politicas-de-privacidad': '/privacy-policies',
            '/contacto': '/contact/',
            '/politicas-de-cookies': '/cookie-policies',
            '/politicas-de-reembolso': '/refund-policies',
            '/preguntas-frecuentes': '/faq',
            '/areas/evaluacion-psiquiatrica': '/areas/psychiatric-evaluation',
            '/areas/evaluacion-psicologica': '/areas/psychological-evaluation',
            '/areas/evaluacion-neurologica': '/areas/neurological-evaluation',
            '/areas/evaluacion-juridica': '/areas/legal-assessment',
            '/consentimiento-informado': '/informed-consent',
        };

        // Reemplazar el idioma en la URL
        let newPath = pathname.replace(/^\/(es|en)/, `/${newLocale}`);
        
        // Si estamos en el root (que ahora será /es o /en por el middleware)
        if (pathname === '/' || pathname === '/es' || pathname === '/en') {
            newPath = `/${newLocale}`;
        }

        // Iterar sobre el mapeo de rutas y actualizar el path si es necesario
        Object.keys(routesMapping).forEach((esRoute) => {
            const enRoute = routesMapping[esRoute];
            if (newLocale === 'en' && pathname.includes(esRoute)) {
                newPath = newPath.replace(esRoute, enRoute);
            } else if (newLocale === 'es' && pathname.includes(enRoute)) {
                newPath = newPath.replace(enRoute, esRoute);
            }
        });

        // Solo recargar si la ruta ha cambiado o el idioma es diferente
        if (newPath !== pathname || newLocale !== locale) {
            window.location.href = newPath;
        }

       
        setIsOpen(false);
    };

    return (
        <>
            <div className={styles.languageSelector}>
                <ul className={styles.languageList}>
                    <li onClick={() => handleChange('es')} className={`${locale === 'es' ? `${styles.active} active` : ''}`}>
                        <ReactCountryFlag countryCode="ES" svg style={{ width: '1em', height: '1em' }} className={locale === 'es' ? 'active' : ''} alt="ES" />
                    </li>
                    <li onClick={() => handleChange('en')} className={`${locale === 'en' ? `${styles.active} active` : ''}`}>
                        <ReactCountryFlag countryCode="GB" svg style={{ width: '1em', height: '1em' }} className={locale === 'en' ? 'active' : ''} alt="EN" />
                    </li>
                </ul>
            </div>
        </>
    );
};

export default LanguageSelector;
